export default __webpack_public_path__ + "static/media/corporate-needs-bg.b6189cc7.png";